<template>
  <div class="faq-area">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="faq-content">
            <span class="top-title">الأسئلة الشائعة</span>
            <h2>كل ما تود معرفته عن الخدمة</h2>
          </div>

          <div class="accordion style-two">
            <div
              class="accordion-item"
              v-for="(item, index) in accordionItems"
              :key="index"
              :class="{ active: activeIndex === index }"
            >
              <h2 class="accordion-header">
                <button
                  class="accordion-button pt-0"
                  type="button"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  @click="toggleAccordion(index)"
                >
                  {{ item.question }}
                </button>
              </h2>
              <div
                class="accordion-collapse collapse show"
                v-show="activeIndex === index"
              >
                <div class="accordion-body">
                  <p>{{ item.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="faq-img">
            <img src="@/assets/images/faq-2.png" alt="faq" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "FAQ",
  setup() {
    const activeIndex = ref<number>(0);

    const accordionItems = [
      {
        question: "ما هي الأجهزة التي تدعم تشغيل الخدمة؟",
        answer:
          "نحن ندعم جميع الأجهزة الذكية! يمكنك تشغيل الاشتراك على الشاشات الذكية (Smart TV)، أجهزة الاندرويد والـ Fire Stick، الهواتف المحمولة (iOS/Android)، أجهزة الكمبيوتر، والـ Apple TV. لا تحتاج لخبرة تقنية، سنرسل لك اسم التطبيق المناسب لجهازك وطريقة تفعيله بثوانٍ.",
      },
      {
        question: "كيف يمكنني الحصول على الدعم الفني؟",
        answer:
          "نوفر لك دعماً فنياً متكاملاً ومباشراً عبر الواتساب على مدار الساعة (24/7). إذا واجهت أي مشكلة في التشغيل أو كان لديك استفسار، يمكنك مراسلتنا فوراً وسيقوم فريقنا بمساعدتك وحل المشكلة مباشرة.",
      },
      {
        question: "كم من الوقت يستغرق تفعيل الاشتراك بعد الدفع؟",
        answer:
          "التفعيل فوري وسريع جداً. بمجرد إتمام عملية الدفع وتأكيدها معنا عبر الواتساب، سيقوم النظام بتوليد بيانات الاشتراك الخاصة بك وإرسالها لك خلال دقائق معدودة لتستمتع بالمشاهدة مباشرة.",
      },
      {
        question: "هل توجد تجربة مجانية قبل الاشتراك؟",
        answer:
          "نعم بكل تأكيد. يمكنك التواصل معنا مباشرة عبر الواتساب وطلب تجربة مجانية تماماً لفترة محدودة، وذلك لتتأكد بنفسك من جودة البث، ثبات السيرفر، وتنوع باقة القنوات والأفلام قبل اتخاذ قرار الشراء.",
      },
      {
        question: "هل يتطلب الاشتراك سرعة إنترنت عالية؟",
        answer:
          "يعمل السيرفر بكفاءة على سرعات الإنترنت المختلفة بفضل تقنيات الضغط الذكية. ومع ذلك، للحصول على أفضل تجربة بث بجودة FHD و 4K بدون أي تذبذب، نوصي باتصال إنترنت مستقر لا يقل عن 20 ميغابت في الثانية.",
      },
    ];

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    return {
      activeIndex,
      toggleAccordion,
      accordionItems,
    };
  },
});
</script>